module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-c6f68314f70535349714dfd285aa0eea.png";